import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LandingNav } from './LandingNav';
import { LandingFooter } from './LandingFooter';
import { Seo } from '../../components/Seo';

export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen flex-col bg-paper-100 font-manuscript">
      <Seo title={t('landing.notFound.seoTitle')} noindex path="/404" />
      <LandingNav />

      <main className="flex flex-1 flex-col">
      <div className="mx-auto flex flex-1 max-w-xl flex-col items-center justify-center px-6 py-24 text-center">
        <p className="font-display text-6xl font-semibold text-seal-500">404</p>
        <h1 className="font-display mt-4 text-3xl font-semibold text-manuscript-ink sm:text-4xl">
          {t('landing.notFound.title')}
        </h1>
        <p className="mt-4 text-manuscript-ink-soft">{t('landing.notFound.subtitle')}</p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 rounded-sm bg-manuscript-ink px-6 py-3 text-sm font-semibold text-paper-50 transition-colors hover:bg-manuscript-ink-soft"
        >
          {t('landing.notFound.backHome')}
          <span aria-hidden>→</span>
        </Link>
      </div>
      </main>

      <LandingFooter />
    </div>
  );
}
